module.exports = __webpack_public_path__ + "static/media/flag_pt_BR.c18b0ed3.png";